import { render } from "./studioAchievement.vue?vue&type=template&id=35895c85&scoped=true"
import script from "./studioAchievement.vue?vue&type=script&lang=js"
export * from "./studioAchievement.vue?vue&type=script&lang=js"

import "./studioAchievement.vue?vue&type=style&index=0&id=35895c85&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35895c85"]])

export default __exports__